import React, { useState, useEffect } from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as user from "../../utils/user.js";
import * as navigation from "../../utils/navigation.js";
import * as language from "../../utils/language.js";

const Register = (props) => {
  //========================================================================
  // Benutzer hinzufügen
  const [groups, setGroups] = useState([]);
  const [username, setUsername] = useState("");
  const [group, setGroup] = useState("");
  const [password, setPassword] = useState("");
  const [expiration, setExpiration] = useState("10m");
  const [feedbackMessage, setFeedbackMessage] = useState("");

  useEffect(() => {
    const fetchGroups = async () => {
      const fetchedGroups = await user.getGroups();
      setGroups(fetchedGroups);
    };

    fetchGroups();
  }, []);

  const handleSubmit = async (e) => {
    const response = await user.register(
      e,
      username,
      group,
      password,
      expiration,
      setFeedbackMessage
    );

    setUsername("");
    setGroup("");
    setPassword("");
    setExpiration("10m");
  };
  console.log(feedbackMessage);

  if (globalVars.auth.createUsers) {
    return (
      <div style={{ ...props.style, backgroundColor: "lightgray" }}>
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "80%",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              color: "black",
              fontSize: "100%",
              padding: "10px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {language.displayText(["Benutzer hinzufügen"])}
          </div>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          />
          <select
            value={group}
            onChange={(e) => setGroup(e.target.value)}
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "110%",
            }}
          >
            <option value="" disabled>
              Select a Group
            </option>
            {groups.map((group) => (
              <option key={group} value={group}>
                {group}
              </option>
            ))}
          </select>
          <input
            type="text"
            value={expiration}
            onChange={(e) => setExpiration(e.target.value)}
            placeholder="Expiration"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          />
          <button
            type="submit"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          >
            Register
          </button>
          {feedbackMessage && (
            <p
              style={{
                color: feedbackMessage.includes("failed") ? "red" : "green",
                textAlign: "center",
              }}
            >
              {feedbackMessage}
            </p>
          )}
        </form>
      </div>
    );
  } else {
    return (
      <div
        style={{
          ...props.style,
          backgroundColor: "lightgray",
        }}
      ></div>
    );
  }
};

export default Register;
